<template>
    <path fill-rule="evenodd" d="M353 1678.999L369 1663 385 1678.999 382.099 1681.806 370.965 1670.673 370.965 1695 367.035 1695 367.035 1670.673 355.807 1681.806z" transform="translate(-353 -1663)"/>
</template>

<script>
export default {
    name: 'arrowUpIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
